import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { PQRFatorPonderacaoDto } from '../../dtos/pqr-fator-ponderacao.dto';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../';

interface ListPQRFatorPonderacao {
  _embedded: {
    'pqr-fator-ponderacao': PQRFatorPonderacaoDto[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PQRFatorPonderacaoService {

  private apiUrl = `${environment.apiUrl}/pqr-fator-ponderacao`;

  constructor(
    private caqRequestService: CaqRequestService
  ) {}

  buscarPQRFatorPonderacao(): Observable<PQRFatorPonderacaoDto> {
    return this.caqRequestService
      .get<ListPQRFatorPonderacao>(this.apiUrl)
      .pipe(map((response) => response._embedded['pqr-fator-ponderacao'][0]));
  }

  salvePQRFatorPonderacao(requisicao: PQRFatorPonderacaoDto){
    // 1. Cria uma cópia do objeto para não afetar o que está sendo exibido na tela
    const payload: any = { ...requisicao };

    // 2. Lista os campos que vêm da tela com vírgula
    const camposNumericos = [
      'pqrFatorPondIndigena',
      'pqrFatorPondQuilombola',
      'pqrFatorPondAee',
      'pqrFatorPondEnsMedioProfissional',
      'pqrFatorPondEjaProfissional'
    ];

    // 3. Substitui a vírgula por ponto e força o tipo para Number
    camposNumericos.forEach(campo => {
      if (payload[campo] !== null && payload[campo] !== undefined) {
        payload[campo] = Number(String(payload[campo]).replace(',', '.'));
      }
    });

    return firstValueFrom(this.caqRequestService
      .put<PQRFatorPonderacaoDto>(`${this.apiUrl}/${requisicao.codigoFatorPonderacao}`, payload)
      .pipe(map((response) => response)));
  }
}
